/**
 * Personal, per-device view preferences — deliberately separate from
 * useAppConfig's tenant-wide admin config. That config's saveConfig() pushes
 * to the shared app-config blob, so storing a user's own list/card choice
 * there would silently overwrite the default every other user sees the next
 * time an admin-tokened browser calls it. This is plain localStorage, same
 * pattern as rowLayout.js's density preference.
 */
const DISPLAY_MODE_KEY = 'peoplevue_display_mode';

export function loadDisplayMode() {
  try {
    const stored = localStorage.getItem(DISPLAY_MODE_KEY);
    return stored === 'list' || stored === 'card' ? stored : null;
  } catch {
    return null;
  }
}

export function saveDisplayMode(mode) {
  try {
    localStorage.setItem(DISPLAY_MODE_KEY, mode);
  } catch {
    // A private-mode storage failure must not break the toggle
  }
}
